package dev.wyns.ventrova.data.sqlite

/** Minimal read-only SQLite access, implemented per platform. */
interface SqlDatabase : AutoCloseable {
    /** Runs [sql] with `?` placeholders bound to [args] (as text). */
    suspend fun query(sql: String, vararg args: String): List<SqlRow>
}

/** Opens a SQLite database from its file contents. */
fun interface SqlDatabaseOpener {
    suspend fun open(name: String, bytes: ByteArray): SqlDatabase
}

/** One result row, keyed by column name. Values are `String`, `Long`, `Double` or null. */
class SqlRow(private val values: Map<String, Any?>) {
    fun string(column: String): String? = (values[column] as? String)?.ifBlank { null }

    fun double(column: String): Double? = (values[column] as? Number)?.toDouble()

    fun long(column: String): Long? = (values[column] as? Number)?.toLong()
}
